import * as React from "react";

interface INumberFormatProps {
    options?: {}
}
export class NumberFormat extends React.Component<INumberFormatProps, {}>{

    getNumberFormatted(value, options) {
        if (!options) {
            options = {};
        }
        let defaultOptions = {
            showMillions: false,
            precision: 2,
            emptyValue: '-'
        };
        let oneMillion = 1000000.00;
        options = Object.assign({}, defaultOptions, options);
        let {showMillions, precision, suffix, prefix, emptyValue} = options;
        if (isNaN(value)) {
            value = parseFloat(value);
        }
        let response = value;
        if (!response || response === '') {
            response = emptyValue;
            return response;
        }
        if (showMillions && value > oneMillion) {
            response = response / oneMillion;
        }
        let formatOptions = {};

        if (precision) {
            if (response) {
                response = parseFloat(response);
                response = response.toFixed(precision);
            }
            else {
                response = 0;
            }
        }
        // response = response.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");


        if (showMillions && value > oneMillion) {
            response += ' million';
        }

        if (prefix) {
            response = prefix + response;
        }
        if (suffix) {
            response += suffix;
        }

        return response;
    }
    render() {
        return (
            <span>{this.getNumberFormatted(this.props.children, this.props.options)}</span>
        );
    }
}


// WEBPACK FOOTER //
// ./src/client/assets/NumberFormat/NumberFormat.tsx